var loaded = {
  v3: new Promise((resolve, reject) => {
    window.recaptchav3loaded = resolve;
  }),
  v2_checkbox: new Promise((resolve, reject) => {
    window.recaptchav2checkboxloaded = resolve;
  }),
};

export function getRecaptchaV3() {
  return new Promise((resolve, reject) => {
    loaded.v3.then(() => {
      if(!grecaptcha) {
        reject({message: "Failed to load reCAPTCHA. Is there an issue with your Internet connection?"});
        return;
      }
      var v3_sitekey = $(".g-recaptcha-v3-cfg").data("sitekey");

      try {
        grecaptcha.execute(v3_sitekey, {action: 'image_upload'}).then(function(token) {
          resolve({
            value: token,
            version: 'v3',
          });
        }, function(error) {
          reject({message: `Failed to run reCAPTCHA. Is there an issue with your Internet connection? (${error})` })
        });
      } catch(e) {
        //if(e instanceof TypeError) {
        //  var knownMessage = `Cannot read property '${v3_sitekey}' of undefined`;
        //}
        if(window.error_tracking) window.error_tracking.sendError(e);
        reject({message: `Failed to run reCAPTCHA. Is there an issue with your Internet connection? (${e}). Try to empty your browser cache and reload the page.` })
      }
    })
  })
}

export function getRecaptchaV2Checkbox(element) {
  return new Promise((resolve, reject) => {
    loaded.v2_checkbox.then(() => {
      var v2_checkbox_sitekey = $(".g-recaptcha-v2-checkbox-cfg").data("sitekey");
      grecaptcha.render(
        element,
        {
          sitekey: v2_checkbox_sitekey,
          callback: resolve,
        }
      )
    })
  });
}
